import React, { useState, useEffect } from "react";
import { message, Select } from "antd";
import { InputItem, ModalItem, SelectItem } from "../../../../../Components/Items";

const { Option } = Select;

const TIPOS_NODO_RAPIDO = [
  { value: "punto_intermedio", label: "Punto intermedio" },
  { value: "entrada", label: "Entrada" },
  { value: "salida", label: "Salida" },
  { value: "acceso_ubicaciones", label: "Acceso a ubicaciones" },
  { value: "estacion", label: "Estación de surtido" },
  { value: "transicion_seccion", label: "Transición entre secciones" },
];

const valoresIniciales = { codigo: "", nombre: "", tipo: "punto_intermedio", seccionAlmacenId: undefined };

const ModalAgregarNodo = ({ visible, onClose, secciones, onConfirmar }) => {
  const [valores, setValores] = useState(valoresIniciales);

  useEffect(() => {
    if (visible) setValores(valoresIniciales);
  }, [visible]);

  const actualizar = (cambios) => setValores((prev) => ({ ...prev, ...cambios }));

  const confirmar = () => {
    if (!valores.codigo) {
      message.warning("Captura un código para el nodo");
      return;
    }
    onConfirmar(valores);
  };

  return (
    <ModalItem
      title="Agregar nodo"
      visible={visible}
      onCancel={onClose}
      onOk={confirmar}
      okText="Continuar y elegir posición"
      width={520}
      footer
      spinning={false}
    >
      <p style={{ color: "#8a93a6", fontSize: 12 }}>
        Cada clic en el lienzo coloca un nodo y sigue en este modo para poner varios seguidos - a partir del 2do, se alinea
        completamente horizontal o vertical respecto al anterior y el código se numera solo. Cancela desde la barra cuando termines.
      </p>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Código</div>
        <InputItem value={valores.codigo} onChange={(e) => actualizar({ codigo: e.target.value })} />
      </div>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Nombre (opcional)</div>
        <InputItem value={valores.nombre} onChange={(e) => actualizar({ nombre: e.target.value })} />
      </div>
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Tipo</div>
        <SelectItem width="100%" value={valores.tipo} onChange={(value) => actualizar({ tipo: value })}>
          {TIPOS_NODO_RAPIDO.map((valorTipo) => (
            <Option key={valorTipo.value} value={valorTipo.value}>
              {valorTipo.label}
            </Option>
          ))}
        </SelectItem>
      </div>
      <div>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Sección (opcional)</div>
        <SelectItem width="100%" allowClear value={valores.seccionAlmacenId} onChange={(value) => actualizar({ seccionAlmacenId: value })}>
          {secciones.map((valorSeccion) => (
            <Option key={valorSeccion._id} value={String(valorSeccion._id)}>
              {valorSeccion.nombre}
            </Option>
          ))}
        </SelectItem>
      </div>
    </ModalItem>
  );
};

export default ModalAgregarNodo;
